import script from "./CalendarDashboardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarDashboardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarDashboardComponent.vue?vue&type=style&index=0&id=253c8510&lang=css"

const __exports__ = script;

export default __exports__